import React, { useState } from "react";
import {
  Box,
  CardMedia,
  Dialog,
  DialogContent,
  IconButton,
  useMediaQuery,
  useTheme,

} from "@mui/material";
import { KeyboardArrowLeft, KeyboardArrowRight, Close } from "@mui/icons-material";

const StepperSlider = ({ mediaContent = [] }) => {
  const theme =useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [activeStep, setActiveStep] = useState(0);
  const [openImageDialog, setOpenImageDialog] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleImageClick = (media, index) => {
    setSelectedImageIndex(index);
    setOpenImageDialog(true);
  };

  const handleDialogNext = () => {
    setSelectedImageIndex((prev) =>
      prev < mediaContent.length - 1 ? prev + 1 : prev
    );
  }

  const handleDialogBack = () => {
    setSelectedImageIndex((prev) => (prev > 0 ? prev - 1 : prev));
  }




  return (
    <>
      <Box
        position="relative"
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* Image Display */}
        <Box
          sx={{
            overflow: "hidden",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {mediaContent.map((media, index) => (
            <CardMedia
              key={index}
              component="img"
              image={(media)}
              alt={`Slide ${index}`}
              onClick={() => handleImageClick(media, index)}

              sx={{
                display: activeStep === index ? "flex" : "none",
                width: "100%",
                height: "100%",
                objectFit: "contain",
                cursor: "pointer",
              }}
            />
          ))}
        </Box>

        {/* Navigation Buttons */}
        {mediaContent.length > 1 && (
          <>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                transform: "translateY(-50%)",
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                px: 1,
              }}
            >
              <IconButton onClick={handleBack} disabled={activeStep === 0}
                sx={{
                  backgroundColor: "rgba(0, 0, 0, 0.1)",
                }}
                size="small"
              >
                <KeyboardArrowLeft />
              </IconButton>
              <IconButton
                onClick={handleNext}
                disabled={activeStep === mediaContent.length - 1}
                sx={{
                  backgroundColor: "rgba(0, 0, 0, 0.1)",
                }}
                size="small"
              >
                <KeyboardArrowRight />
              </IconButton>
            </Box>

            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                display: "flex",
                justifyContent: "center",
                width: "100%",
                py: 1,
              }}
            >
              {mediaContent.map((_, index) => (
                <Box
                  key={index}
                  sx={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    backgroundColor: activeStep === index ? "#ff7272" : "#d5d5d5",
                    mx: 0.5,
                  }}
                />
              ))}
            </Box>
          </>
        )}
      </Box>

      {/* Image Dialog */}
      <Dialog
        fullScreen
        open={openImageDialog}
        onClose={() => setOpenImageDialog(false)}
        PaperProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(1px)",
            boxShadow: "none",
          },
        }}
      >
        <DialogContent
          sx={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 0,
            position: "relative",
            bgcolor: "transparent",
          }}
          onClick={() => setOpenImageDialog(false)}
        >
          <Box sx={{ position: "relative" }}>
            <IconButton
              onClick={() => setOpenImageDialog(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: "white",
                zIndex: 1,
                bgcolor: "rgba(220, 32, 32, 0.5)",
                "&:hover": {
                  bgcolor: "primary.main",
                },
              }}
            >
              <Close />
            </IconButton>
            {selectedImageIndex !== null && (
              <>
                <CardMedia
                  component="img"
                  image={mediaContent[selectedImageIndex]}
                  alt="post image"
                  sx={{
                    backgroundColor: "rgba(244, 237, 237, 0.57)",
                    width: "100%",
                    height: { xs: "400px", sm: "600px" },
                    objectFit: "contain",
                    aspectRatio: "4 / 3",
                  }}
                />
                {mediaContent.length > 1 && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: 0,
                      right: 0,
                      transform: "translateY(-50%)",
                      display: "flex",
                      justifyContent: "space-between",
                      px: 2,
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <IconButton
                      onClick={handleDialogBack}
                      disabled={selectedImageIndex === 0}
                      sx={{
                        backgroundColor: "rgba(54, 52, 52, 0.97)",
                        color: "white",
                        "&:hover": {
                          backgroundColor: "rgba(255, 255, 255, 0.5)",
                          color: "black",
                        },
                      }}
                    >
                      <KeyboardArrowLeft />
                    </IconButton>
                    <IconButton
                      onClick={handleDialogNext}
                      disabled={selectedImageIndex === mediaContent.length - 1}
                      sx={{
                        backgroundColor: "rgba(54, 52, 52, 0.97)",
                        color: "white",
                        "&:hover": {
                          backgroundColor: "rgba(255, 255, 255, 0.5)",
                          color: "black",
                        },
                      }}
                    >
                      <KeyboardArrowRight />
                    </IconButton>
                  </Box>
                )}
              </>
            )}
          </Box>
        </DialogContent>

      </Dialog>

    </>
  );
};

export default StepperSlider;
